module.exports = __webpack_public_path__ + "media/images/boy-girl-0182744bd5325f33ae4687c48ba2fcb5.png";